import { render, staticRenderFns } from "./UploadDocuments.vue?vue&type=template&id=3620f5fd"
import script from "./UploadDocuments.vue?vue&type=script&lang=js"
export * from "./UploadDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports